import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=c89f3b36&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=ts"
export * from "./eventList.vue?vue&type=script&lang=ts"
import style0 from "./eventList.vue?vue&type=style&index=0&id=c89f3b36&prod&lang=scss"
import style1 from "./eventList.vue?vue&type=style&index=1&id=c89f3b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f3b36",
  null
  
)

export default component.exports